import React from 'react';

import classNames from 'classnames';

interface SkeletonProps {
  className?: string;
  'data-testid'?: string;
}

const baseClasses =
  'block bg-black/10 animate-pulse motion-reduce:animate-none';

const Skeleton = ({ className, 'data-testid': testId }: SkeletonProps) => (
  <span data-testid={testId} className={classNames(baseClasses, className)} />
);

export default Skeleton;
